<template>
  <div v-if="show" class="slider-container-wrap">
    <div class="slider-container">
      <div class="background"></div>
      <div class="filled" :style="{ width: `${this.rangeValue * 100}%` }"></div>
      <input type="range" min="0" max="1" step="0.01" class="slider"
             v-model="rangeValue">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SliderVolume',

    props: {
      show: { type: Boolean, default: true },
      isVertical: { type: Boolean, default: true },
      initialValue: { type: Number, default: 0 }
    },

    data() {
      return {
        rangeValue: 0
      }
    },

    watch: {
      rangeValue: function (value) {
        this.$emit('valueChange', value)
      }
    },

    mounted() {
      this.rangeValue = this.initialValue
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/styles/mixins";

  $color-active: #d3d3d3;
  $background-color-default: #555;
  $background-color-active: #d3d3d3;

  .slider-container-wrap {
    background-color: hsla(0, 0%, 100%, .5);
    @include border-radius(4px);
    width: 100%;
    height: 100%;
    padding: 0 10px;
    opacity: .7;

    &:hover {
      opacity: 1;
    }
  }

  .slider-container {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0 auto;

    .background,
    .filled,
    .slider {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 5px;
      margin: 0;
      @include border-radius(15px);
      @include transform-translate(0, -50%);
    }

    .background {
      background-color: $background-color-default;
      @include transition(opacity .2s);
      width: 100%;
    }

    .filled {
      width: 0;
      background-color: $background-color-active;
      @include transition(opacity .2s);
    }

    .slider {
      cursor: pointer;
      -webkit-appearance: none;
      width: 100%;
      background: transparent;
      outline: none;
      margin: 0;
      @include transition(opacity .2s);

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 20px;
        height: 20px;
        @include border-radius(50%);
        background: $color-active;
        cursor: pointer;
        @include transition(opacity .2s);
      }

      &::-moz-range-thumb {
        width: 20px;
        height: 20px;
        @include border-radius(50%);
        background: $color-active;
        cursor: pointer;
        @include transition(opacity .2s);
      }
    }
  }
</style>
